import { CustomCellRendererProps } from 'ag-grid-react'

import { useCurrencies } from '@/react-query/queries/currencies'

export interface CurrencyIdCellRendererProps extends CustomCellRendererProps {}

export const CurrencyIdCellRenderer: React.FC<CurrencyIdCellRendererProps> = ({ value }) => {
  const query = useCurrencies()

  const label = query.data?.find((c) => c.value == value)?.label ?? value

  return <>{label}</>
}
